import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import Navbar from './Navbar';
import Footer from './Footer';
import PressGallery from './PressGallery';
import { mediaUrl } from '../utils/media';

const TestimonialPage: React.FC = () => {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });

    // Hide spinner after page loads
    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 500);
    }

    // Back to top button functionality
    const backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          (backToTop as HTMLElement).style.display = 'block';
        } else {
          (backToTop as HTMLElement).style.display = 'none';
        }
      };

      window.addEventListener('scroll', handleScroll);

      backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <>
      <div
        id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
      >
        <div className="spinner-grow text-primary" role="status"></div>
      </div>

      <Navbar />

      {/* Page Header Start */}
      <div
        className="container-fluid page-header testimonial-page-header mb-5"
        data-aos="fade"
        data-aos-delay="100"
        style={{ background: `linear-gradient(rgba(0, 29, 35, .36), rgba(0, 29, 35, .36)), url(${mediaUrl('testimonial-header.jpg')}) center center / cover no-repeat` }}
      >
        <div className="container text-center">
          <h1 className="display-4 text-white animated slideInDown mb-4" data-aos="fade-down">
            Testimonial
          </h1>
          <nav aria-label="breadcrumb animated slideInDown" data-aos="fade-down" data-aos-delay="200">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-white">Pages</span>
              </li>
              <li className="breadcrumb-item text-primary active" aria-current="page">
                Testimonial
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* Page Header End */}

      {/* Testimonial Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mx-auto mb-5" data-aos="fade-up" data-aos-delay="100" style={{ maxWidth: '500px' }}>
            <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
              Testimonial
            </div>
            <h1 className="display-6 mb-5">What People Say About Us</h1>
          </div>
          <PressGallery />
        </div>
      </div>
      {/* Testimonial End */}

      <Footer />

      <button type="button" className="btn btn-lg btn-primary btn-lg-square back-to-top" aria-label="Back to top">
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
};

export default TestimonialPage;

